export default __webpack_public_path__ + "static/media/surgery.32b4e7a0.png";